// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2451f43","455":"609d5036","578":"2da53c61","844":"217c6d6a","857":"91b67dbb","977":"849974e2"}[chunkId] + ".chunk.js";
};